import React, { useFormContext, useController } from 'react-hook-form'

const withField = Comp => props => {
  const { control, ...form } = useFormContext()
  // eslint-disable-next-line react/prop-types
  const { field, fieldState } = useController({ name: props.name, control })
  return <Comp {...props} field={field} form={form} meta={fieldState} />
}

export default withField
